import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faSpinner,
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import constants from "../../../utils/constants";

interface TableProps {
  page: any;
  loading: boolean;
  onFetchData: (state: any) => void;
}

export const MemoTable = React.memo<TableProps>(
  ({ page, loading, onFetchData }) => {
    const [columns, setColumns] = useState(columnsFormatter());
    const [pageNumber, setPageNumber] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
      setColumns(columnsFormatter());
    }, []);

    useEffect(() => {
      if (page) {
        setPageNumber(page.number || 0);
        setTotalPages(page.totalPages || 0);
      }
    }, [page]);

    const mostrados = page && page.numberOfElements;
    const totales = page && page.totalElements;

    return (
      <>
        {/* Información de registros */}
        <div>
          {!!page && !!page.content && !!page.content.length ? (
            <div className="col-6 p-0">
              <span>
                Reportes mostrados: {mostrados} de {totales}
              </span>
            </div>
          ) : (
            <div className="col-6 p-0">
              <span>Reportes mostrados: 0</span>
            </div>
          )}
        </div>

        {/* Tabla */}
        <div className="mt-2">
          <div style={{ width: "100%" }}>
            <ReactTable
              manual
              data={(page && page.content) || []}
              columns={columns}
              loading={loading}
              defaultPageSize={10}
              onFetchData={onFetchData}
              page={pageNumber}
              pages={totalPages}
              showPagination={true}
              showPageSizeOptions={false}
              getTrProps={() => ({ style: { height: "40px" } })}
              sortable={false}
              previousText="Anterior"
              nextText="Siguiente"
              loadingText="Cargando..."
              noDataText="No hay registros"
              pageText="Página"
              ofText="de"
              rowsText="filas"
            />
          </div>
        </div>
      </>
    );
  }
);

const columnsFormatter = () => {
  return [
    {
      Header: "Id",
      accessor: "id",
      width: 80,
      Cell: (row: any) => <div className="text-center">{row.value}</div>
    },
    {
      Header: "Fecha Inicio",
      accessor: "fechaInicio",
      width: 180,
      Cell: (row: any) =>
        row.value ? moment(row.value).format("DD/MM/YYYY HH:mm") : "-"
    },
    {
      Header: "Fecha Fin",
      accessor: "fechaFin",
      width: 180,
      Cell: (row: any) =>
        row.value ? moment(row.value).format("DD/MM/YYYY HH:mm") : "-"
    },
    {
      Header: "Estatus",
      accessor: "estatus",
      width: 150,
      Cell: (row: any) => {
        const estatus = row.value;
        let icon = faSpinner;
        let color = "text-warning";
        let text = "Procesando";
        let spin = true;

        if (estatus === "COMPLETADO") {
          icon = faCheckCircle;
          color = "text-success";
          text = "Completado";
          spin = false;
        } else if (estatus === "ERROR") {
          icon = faTimesCircle;
          color = "text-danger";
          text = "Error";
          spin = false;
        }

        return (
          <div className="text-center">
            <FontAwesomeIcon icon={icon} className={color} spin={spin} /> {text}
          </div>
        );
      }
    },
    {
      Header: "Descargar",
      accessor: "idFile",
      width: 120,
      Cell: (row: any) => {
        const { idFile, estatus } = row.original;
        if (estatus === "COMPLETADO" && idFile) {
          return (
            <div className="text-center">
              <a
                href={`${constants.BASE_URL}/api/partners/membership-partner/documents/${idFile}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-primary"
              >
                <FontAwesomeIcon icon={faDownload} /> CSV
              </a>
            </div>
          );
        }
        return <div className="text-center">-</div>;
      }
    }
  ];
};
